export default {
    FALTA_EM_ESTOQUE: 1,
    FORA_DA_REMUME: 2,
    QUEBRADO_INDISPONIVEL: 3,
    OUTROS: 4
}